(function() {
	'use strict';

	angular.module('adjustBenApp').controller('AdjustBenController',AdjustBenController);

	AdjustBenController.$inject = [ '$scope','$stateParams','$state','$window','$base64', 'AdjustBenService','CommonService','$location','$http','$uibModal', '$log', 'Upload','NgTableParams','FileNetService','authExpiredInterceptor','CustomerInfoService' ];

	function AdjustBenController($scope,$stateParams,$state,$window,$base64, AdjustBenService,CommonService, $location , $http, $uibModal, $log, Upload,NgTableParams,FileNetService,authExpiredInterceptor,CustomerInfoService) {
		var adjustBenCtrl = this;
		var param = $stateParams;
		var toDate=new Date();
		$scope.loading=false;
		var yesterday = new Date(toDate.getTime());
		yesterday.setDate(toDate.getDate() - 1);
		adjustBenCtrl.validateGender=false;
		adjustBenCtrl.policyDTO={};
		adjustBenCtrl.checkError = false;
//		adjustBenCtrl.checkInvalid=true;
		adjustBenCtrl.checkPolicy=false;
		adjustBenCtrl.showDetails=false;
		adjustBenCtrl.genderTypes=genderTypes;
		adjustBenCtrl.marriedTypes=marriedTypes;
		adjustBenCtrl.agreeEmailTypes=agreeEmailTypes;
		adjustBenCtrl.agreeSmsTypes=agreeSmsTypes;
		adjustBenCtrl.salutlTypes=salutlTypes;
		adjustBenCtrl.lstNationality = CommonService.query({masterurl:'nationality'});
    	adjustBenCtrl.lstProvince = CommonService.query({masterurl:'province'});
    	adjustBenCtrl.lstOcupation =CommonService.query({masterurl:'occupation'});
    	adjustBenCtrl.lstPhoneCode=CommonService.query({masterurl:'phone-code'});
    	adjustBenCtrl.lstReceiver=[];
    	adjustBenCtrl.checkCreate=false;
//    	adjustBenCtrl.checkValidate = function(){
//    		var checkAttachment=true;
//    		var checkPolicy=true;
//    		var checkTable=true;
//    		if(adjustBenCtrl.attachment != null && adjustBenCtrl.attachment.name != null){
//    			adjustBenCtrl.checkInvalid=false;
//    		}
//    		
//    	}
    	adjustBenCtrl.changeGender=function(){
    		if(adjustBenCtrl.policyDTO.customer.salutation==salutlTypes[0].codeSalutl){
    			if(adjustBenCtrl.policyDTO.customer.gender=='M'){
    				adjustBenCtrl.validateGender=false;
    			}else{
    				adjustBenCtrl.validateGender=true;
    			}
    		}else if(adjustBenCtrl.policyDTO.customer.salutation==salutlTypes[1].codeSalutl||adjustBenCtrl.policyDTO.customer.salutation==salutlTypes[3].codeSalutl){
    			if(adjustBenCtrl.policyDTO.customer.gender=='F'){
    				adjustBenCtrl.validateGender=false;
    			}else{
    				adjustBenCtrl.validateGender=true;
    			}
    		}else{
    			adjustBenCtrl.validateGender=false;
    		}
    	}
    	adjustBenCtrl.loadPopup = function(clientCode){		
			CustomerInfoService.get({uri : 'getCustomerDetail',clientCode : clientCode},function(result){
				var modalInstance = $uibModal
						.open({
							animation : true,
							templateUrl : GLOBAL_URL
							+ 'partial?uri=ga/history/customerinfo/layout/tabDetailPopup',
							controller : 'CustomerInfoPopupController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								vmClient : function() {
									return result;
								}
							}
						});
					modalInstance.result.then(function(clientCode) {
						//adjustBenCtrl.loadCustomerInfo(clientCode);
						modalInstance = null;
					}, function() {
				});
			});
		};
    	adjustBenCtrl.dateOptions = {
			    maxDate: yesterday
			  };
    	adjustBenCtrl.getAllDistrictByProvince = function(cityCode){
    		if (cityCode != null || cityCode != undefined && (num != null || num != undefined)){
    			adjustBenCtrl.lstDistrict = CommonService.query({masterurl:'district',provinceCode:cityCode});
    		}else{
    			adjustBenCtrl.lstDistrict = null;
    		}
    	}
    	// Get Wards
    	adjustBenCtrl.getAllWardByDistrict = function(districtCode){
    		if (districtCode != null || districtCode != undefined && (districtCode != null || districtCode != undefined)){
    			adjustBenCtrl.lstWard = CommonService.query({masterurl:'ward',districtCode:districtCode});
    		}else{
    			adjustBenCtrl.lstWard = null;
    		}
    	}
		adjustBenCtrl.findPolicy = function() {
			$scope.loading=true;
			AdjustBenService.get({
				uri : 'getInfoPolicy',
				policyNum : adjustBenCtrl.policyDTO.policyNum
			}, function(result) {
				if(result.flagError==0){
					adjustBenCtrl.policyDTO = result;
					adjustBenCtrl.ownerCode=result.ownerCode;
					adjustBenCtrl.ownerName="-" +result.ownerName;
					adjustBenCtrl.mobile=result.mobilePhone;
					adjustBenCtrl.checkPolicy=true;
					adjustBenCtrl.birthDate=null;
					adjustBenCtrl.idNumDate=null;
					adjustBenCtrl.agent=result.servicingAgentCode+"-"+result.servicingAgentName;
				}
				$scope.loading=false;
			}, function(error) {
				$scope.loading=false;
			});
		}
		adjustBenCtrl.clear = function() {
			$state.go($state.current, {}, {
				reload : true
			});
//			adjustBenCtrl.policyDTO = null;
//			adjustBenCtrl.ownerCode=null;
//			adjustBenCtrl.ownerName=null;
//			adjustBenCtrl.mobile=null;
//			adjustBenCtrl.agent=null;
//			adjustBenCtrl.checkCreate = false;
//			adjustBenCtrl.checkPolicy=false;
//			adjustBenCtrl.attachment=null;
//			adjustBenCtrl.adjustBenForm.$setPristine();
//			adjustBenCtrl.adjustBenForm.$setUntouched();
////			adjustBenCtrl.tableParams.data.length=0;
//			adjustBenCtrl.lstReceiver.length=0;
//			adjustBenCtrl.tableParams.reload();
		}
		adjustBenCtrl.addReceiver=function(){
			var item={customer:adjustBenCtrl.policyDTO.customer};
			delete adjustBenCtrl.policyDTO.customer;
			item.customer.birthDate=adjustBenCtrl.birthDate;
			if(adjustBenCtrl.idNumDate!=null||adjustBenCtrl.idNumDate!=undefined){
				item.customer.idNumDate=adjustBenCtrl.idNumDate;
			}
			adjustBenCtrl.lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
			item.lstRelationShip=adjustBenCtrl.lstRelationShip;
    		var dd = item.customer.birthDate.getDate();
    		var mm = item.customer.birthDate.getMonth()+1; //January is 0!
    		var yyyy = item.customer.birthDate.getFullYear();
    		if(dd<10) {
    		    dd='0'+dd
    		} 

    		if(mm<10) {
    		    mm='0'+mm
    		} 

    		item.benBirthDate = dd+'/'+mm+'/'+yyyy;
//    		var ddId = item.customer.idNumDate.getDate();
//    		var mmId = item.customer.idNumDate.getMonth()+1; //January is 0!
//    		var yyyyId = item.customer.idNumDate.getFullYear();
//    		if(ddId<10) {
//    			ddId='0'+ddId
//    		} 
//
//    		if(mmId<10) {
//    			mmId='0'+mmId
//    		} 
//
//    		item.benBirthDate = ddId+'/'+mmId+'/'+yyyyId;
    		if(item.customer.clientCode!=undefined){
    			item.benCode=item.customer.clientCode;
    		}else{
    			item.benCode='NaN';
    		}
			item.benName=item.customer.lastName.toUpperCase() + ' ' + item.customer.firstName.toUpperCase();
			adjustBenCtrl.lstReceiver.push(item);
			adjustBenCtrl.showDetails=!adjustBenCtrl.showDetails;
			adjustBenCtrl.birthDate=null;
			adjustBenCtrl.lstWard=null;
			adjustBenCtrl.lstDistrict=null;
			adjustBenCtrl.tableParams = new NgTableParams({
				
		  	    }, {
		  	      counts: [], // hide page counts control
		  	      filterDelay: 0,
		  	      dataset: adjustBenCtrl.lstReceiver
		  	 });
		}
		adjustBenCtrl.editReceiver=function(){
			var item={customer:adjustBenCtrl.policyDTO.customer};
			delete adjustBenCtrl.policyDTO.customer;
			item.customer.birthDate=adjustBenCtrl.birthDate;
			adjustBenCtrl.lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
			item.lstRelationShip=adjustBenCtrl.lstRelationShip;
    		var dd = item.customer.birthDate.getDate();
    		var mm = item.customer.birthDate.getMonth()+1; //January is 0!
    		var yyyy = item.customer.birthDate.getFullYear();
    		if(dd<10) {
    		    dd='0'+dd
    		} 

    		if(mm<10) {
    		    mm='0'+mm
    		} 

    		item.benBirthDate = dd+'/'+mm+'/'+yyyy;
    		if(item.customer.clientCode!=undefined){
    			item.benCode=item.customer.clientCode;
    		}else{
    			item.benCode='NaN';
    		}
    		if(adjustBenCtrl.policyDTO.benRatio!=undefined){
    			item.benRatio=adjustBenCtrl.policyDTO.benRatio;
    		}
    		if(adjustBenCtrl.policyDTO.benRelation!=undefined){
    			item.benRelation=adjustBenCtrl.policyDTO.benRelation;
    		}
    		if(adjustBenCtrl.policyDTO.adjustBenId!=undefined){
    			item.adjustBenId=adjustBenCtrl.policyDTO.adjustBenId;
    		}
			item.benName=item.customer.lastName.toUpperCase() + ' ' + item.customer.firstName.toUpperCase();
			adjustBenCtrl.lstReceiver.push(item);
			adjustBenCtrl.birthDate=null;
			adjustBenCtrl.lstWard=null;
			adjustBenCtrl.lstDistrict=null;
			adjustBenCtrl.tableParams = new NgTableParams({
				
	  	    }, {
	  	      counts: [], // hide page counts control
	  	      filterDelay: 0,
	  	      dataset: adjustBenCtrl.lstReceiver
	  	 });
		}
		adjustBenCtrl.deleteReceiver = function (idx ) {
			  adjustBenCtrl.tableParams.data.splice(idx, 1);
			  adjustBenCtrl.lstReceiver.splice(idx, 1);
			  adjustBenCtrl.tableParams.reload();
		}
		//begin
		if (param.txnId != undefined && param.txnId != ''&&param.taskId!=null&&param.taskId!=undefined) {
			adjustBenCtrl.displayApprove=true;
			adjustBenCtrl.checkToApprove = true;
			 var txnId = $base64.decode(param.txnId)
			 //get policy info
			 AdjustBenService.get({uri : 'getPoInfoByTxnId',txnId : txnId
				},function(result) {
					if (result != null) {
						adjustBenCtrl.poInfo = result;
						AdjustBenService.get({uri : 'getPoliciByTxnId',txnId : txnId}, 
						function(result2) {
							if(result2 != null){
								adjustBenCtrl.policyDTO = result2;
								adjustBenCtrl.ownerCode=adjustBenCtrl.poInfo.ownerCode;
								adjustBenCtrl.ownerName="-" +adjustBenCtrl.poInfo.ownerName;
								adjustBenCtrl.mobile=adjustBenCtrl.poInfo.mobilePhone;
								adjustBenCtrl.agent=adjustBenCtrl.poInfo.servicingAgentCode+'-'+adjustBenCtrl.poInfo.servicingAgentName;
								adjustBenCtrl.policyDTO.policyNum=adjustBenCtrl.poInfo.policyNum;
								adjustBenCtrl.policyDTO.address=adjustBenCtrl.poInfo.address;
								adjustBenCtrl.policyDTO.wardDesc=adjustBenCtrl.poInfo.wardDesc;
								adjustBenCtrl.policyDTO.districtDesc=adjustBenCtrl.poInfo.districtDesc;
								adjustBenCtrl.policyDTO.contractDesc=adjustBenCtrl.poInfo.contractDesc
								adjustBenCtrl.policyDTO.cityDesc=adjustBenCtrl.poInfo.cityDesc;
								adjustBenCtrl.attachment={name:adjustBenCtrl.policyDTO.archiveData.dataName,content:adjustBenCtrl.policyDTO.archiveData.content,type:adjustBenCtrl.policyDTO.archiveData.dataType};
								
								if (adjustBenCtrl.policyDTO.archiveDataId != null) {
									adjustBenCtrl.attachmentLstDL = {
										name:adjustBenCtrl.policyDTO.archiveDataId.dataName, 
										content:adjustBenCtrl.policyDTO.archiveDataId.content, 
										type:adjustBenCtrl.policyDTO.archiveDataId.dataType};
								}
								
								adjustBenCtrl.policyDTO.taskInstanceId=$base64.decode(param.taskId);
								for(var i=0;i<adjustBenCtrl.policyDTO.lstBenDTO.length;i++){
									if(adjustBenCtrl.policyDTO.lstBenDTO[i].benCode==undefined){
										adjustBenCtrl.policyDTO.lstBenDTO[i].benCode='NaN';
						    		}
									adjustBenCtrl.policyDTO.lstBenDTO[i].lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
								}
								adjustBenCtrl.tableParams = new NgTableParams({
									
						  	    }, {
						  	      counts: [], // hide page counts control
						  	      filterDelay: 0,
						  	      dataset: adjustBenCtrl.policyDTO.lstBenDTO
						  	    });
//								ADJUST_BEN_APP
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_APP'){
									adjustBenCtrl.checkToApproval=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_PROCESS'){
									adjustBenCtrl.checkToProcess=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_LAS'){
				    				adjustBenCtrl.checkApprove=true;
//				    		    	adjustBenCtrl.checkCancel=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.adjustRemark!=null){
									adjustBenCtrl.cancelSuccess= true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.transactions.txnEnable=='1'){
									adjustBenCtrl.finish= true;
								}
							}
						}, function(error){
							adjustBenCtrl.poInfo = {};
							adjustBenCtrl.pvInfo = {}
			    		});
					}
					
					
			 }, function(error){
				 adjustBenCtrl.poInfo = {};
				 adjustBenCtrl.pvInfo = {};
    			});
		} else if (param.policyNum !== undefined && param.policyNum !== '' && param.policyNum !== null) {
			adjustBenCtrl.displayApprove=true;
			adjustBenCtrl.checkToApprove = true;
			 var policyNum = $base64.decode(param.policyNum)
			 //get policy info
			 AdjustBenService.get({uri : 'getPoInfoByPolicyNum', policyNum : policyNum
				},function(result) {
					if (result != null) {
						adjustBenCtrl.poInfo = result;
						AdjustBenService.get({uri : 'getPoliciByPolicyNum', policyNum : policyNum}, 
						function(result2) {
							if(result2 != null){
								adjustBenCtrl.policyDTO = result2;
								adjustBenCtrl.ownerCode=adjustBenCtrl.poInfo.ownerCode;
								adjustBenCtrl.ownerName="-" +adjustBenCtrl.poInfo.ownerName;
								adjustBenCtrl.mobile=adjustBenCtrl.poInfo.mobilePhone;
								adjustBenCtrl.agent=adjustBenCtrl.poInfo.servicingAgentCode+'-'+adjustBenCtrl.poInfo.servicingAgentName;
								adjustBenCtrl.policyDTO.policyNum=adjustBenCtrl.poInfo.policyNum;
								adjustBenCtrl.policyDTO.address=adjustBenCtrl.poInfo.address;
								adjustBenCtrl.policyDTO.wardDesc=adjustBenCtrl.poInfo.wardDesc;
								adjustBenCtrl.policyDTO.districtDesc=adjustBenCtrl.poInfo.districtDesc;
								adjustBenCtrl.policyDTO.contractDesc=adjustBenCtrl.poInfo.contractDesc
								adjustBenCtrl.policyDTO.cityDesc=adjustBenCtrl.poInfo.cityDesc;
								adjustBenCtrl.attachment={name:adjustBenCtrl.policyDTO.archiveData.dataName,content:adjustBenCtrl.policyDTO.archiveData.content,type:adjustBenCtrl.policyDTO.archiveData.dataType};
								
								if (adjustBenCtrl.policyDTO.archiveDataId != null) {
									adjustBenCtrl.attachmentLstDL = {
										name:adjustBenCtrl.policyDTO.archiveDataId.dataName, 
										content:adjustBenCtrl.policyDTO.archiveDataId.content, 
										type:adjustBenCtrl.policyDTO.archiveDataId.dataType};
								}
								
								adjustBenCtrl.policyDTO.taskInstanceId=$base64.decode(param.taskId);
								for(var i=0;i<adjustBenCtrl.policyDTO.lstBenDTO.length;i++){
									if(adjustBenCtrl.policyDTO.lstBenDTO[i].benCode==undefined){
										adjustBenCtrl.policyDTO.lstBenDTO[i].benCode='NaN';
						    		}
									adjustBenCtrl.policyDTO.lstBenDTO[i].lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
								}
								adjustBenCtrl.tableParams = new NgTableParams({
									
						  	    }, {
						  	      counts: [], // hide page counts control
						  	      filterDelay: 0,
						  	      dataset: adjustBenCtrl.policyDTO.lstBenDTO
						  	    });
//								ADJUST_BEN_APP
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_APP'){
									adjustBenCtrl.checkToApproval=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_PROCESS'){
									adjustBenCtrl.checkToProcess=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_LAS'){
				    				adjustBenCtrl.checkApprove=true;
//				    		    	adjustBenCtrl.checkCancel=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.adjustRemark!=null){
									adjustBenCtrl.cancelSuccess= true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.transactions.txnEnable=='1'){
									adjustBenCtrl.finish= true;
								}
							}
						}, function(error){
							adjustBenCtrl.poInfo = {};
							adjustBenCtrl.pvInfo = {}
			    		});
					}
					
					
			 }, function(error){
				 adjustBenCtrl.poInfo = {};
				 adjustBenCtrl.pvInfo = {};
    			});
		}
		if (param.txnId != undefined && param.txnId != ''&&param.taskId==null&&param.taskId==undefined) {
			adjustBenCtrl.displayApprove=true;
			adjustBenCtrl.checkCreate = true;
			 var txnId = $base64.decode(param.txnId)
			 //get policy info
			 AdjustBenService.get({uri : 'getPoInfoByTxnId',txnId : txnId
				},function(result) {
					if (result != null) {
						adjustBenCtrl.poInfo = result;
						AdjustBenService.get({uri : 'getPoliciByTxnId',txnId : txnId}, 
						function(result2) {
							if(result2 != null){
								adjustBenCtrl.policyDTO = result2;
								adjustBenCtrl.ownerCode=adjustBenCtrl.poInfo.ownerCode;
								adjustBenCtrl.ownerName="-" +adjustBenCtrl.poInfo.ownerName;
								adjustBenCtrl.mobile=adjustBenCtrl.poInfo.mobilePhone;
								adjustBenCtrl.agent=adjustBenCtrl.poInfo.servicingAgentCode+'-'+adjustBenCtrl.poInfo.servicingAgentName;
								adjustBenCtrl.policyDTO.policyNum=adjustBenCtrl.poInfo.policyNum;
								adjustBenCtrl.policyDTO.address=adjustBenCtrl.poInfo.address;
								adjustBenCtrl.policyDTO.wardDesc=adjustBenCtrl.poInfo.wardDesc;
								adjustBenCtrl.policyDTO.districtDesc=adjustBenCtrl.poInfo.districtDesc;
								adjustBenCtrl.policyDTO.contractDesc=adjustBenCtrl.poInfo.contractDesc
								adjustBenCtrl.policyDTO.cityDesc=adjustBenCtrl.poInfo.cityDesc;
								adjustBenCtrl.attachment={name:adjustBenCtrl.policyDTO.archiveData.dataName,content:adjustBenCtrl.policyDTO.archiveData.content,type:adjustBenCtrl.policyDTO.archiveData.dataType};
								
								if (adjustBenCtrl.policyDTO.archiveDataId != null) {
									adjustBenCtrl.attachmentLstDL = {
										name:adjustBenCtrl.policyDTO.archiveDataId.dataName, 
										content:adjustBenCtrl.policyDTO.archiveDataId.content, 
										type:adjustBenCtrl.policyDTO.archiveDataId.dataType};
								}
								
								for(var i=0;i<adjustBenCtrl.policyDTO.lstBenDTO.length;i++){
									if(adjustBenCtrl.policyDTO.lstBenDTO[i].benCode==undefined){
										adjustBenCtrl.policyDTO.lstBenDTO[i].benCode='NaN';
						    		}
									adjustBenCtrl.policyDTO.lstBenDTO[i].lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
								}
								adjustBenCtrl.tableParams = new NgTableParams({
									
						  	    }, {
						  	      counts: [], // hide page counts control
						  	      filterDelay: 0,
						  	      dataset: adjustBenCtrl.policyDTO.lstBenDTO
						  	    });
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.transactions.txnEnable=='1'){
									adjustBenCtrl.finish= true;
								}
							}
						}, function(error){
							adjustBenCtrl.poInfo = {};
							adjustBenCtrl.pvInfo = {}
			    		});
					}
					
					
			 }, function(error){
				 adjustBenCtrl.poInfo = {};
				 adjustBenCtrl.pvInfo = {};
    			});
		} else if (param.policyNum !== undefined && param.policyNum !== '' && param.policyNum !== null) {
			adjustBenCtrl.displayApprove=true;
			adjustBenCtrl.checkToApprove = true;
			 var policyNum = $base64.decode(param.policyNum)
			 //get policy info
			 AdjustBenService.get({uri : 'getPoInfoByPolicyNum', policyNum : policyNum
				},function(result) {
					if (result != null) {
						adjustBenCtrl.poInfo = result;
						AdjustBenService.get({uri : 'getPoliciByPolicyNum', policyNum : policyNum}, 
						function(result2) {
							if(result2 != null){
								adjustBenCtrl.policyDTO = result2;
								adjustBenCtrl.ownerCode=adjustBenCtrl.poInfo.ownerCode;
								adjustBenCtrl.ownerName="-" +adjustBenCtrl.poInfo.ownerName;
								adjustBenCtrl.mobile=adjustBenCtrl.poInfo.mobilePhone;
								adjustBenCtrl.agent=adjustBenCtrl.poInfo.servicingAgentCode+'-'+adjustBenCtrl.poInfo.servicingAgentName;
								adjustBenCtrl.policyDTO.policyNum=adjustBenCtrl.poInfo.policyNum;
								adjustBenCtrl.policyDTO.address=adjustBenCtrl.poInfo.address;
								adjustBenCtrl.policyDTO.wardDesc=adjustBenCtrl.poInfo.wardDesc;
								adjustBenCtrl.policyDTO.districtDesc=adjustBenCtrl.poInfo.districtDesc;
								adjustBenCtrl.policyDTO.contractDesc=adjustBenCtrl.poInfo.contractDesc
								adjustBenCtrl.policyDTO.cityDesc=adjustBenCtrl.poInfo.cityDesc;
								adjustBenCtrl.attachment={name:adjustBenCtrl.policyDTO.archiveData.dataName,content:adjustBenCtrl.policyDTO.archiveData.content,type:adjustBenCtrl.policyDTO.archiveData.dataType};
								
								if (adjustBenCtrl.policyDTO.archiveDataId != null) {
									adjustBenCtrl.attachmentLstDL = {
										name:adjustBenCtrl.policyDTO.archiveDataId.dataName, 
										content:adjustBenCtrl.policyDTO.archiveDataId.content, 
										type:adjustBenCtrl.policyDTO.archiveDataId.dataType};
								}
								
								adjustBenCtrl.policyDTO.taskInstanceId=$base64.decode(param.taskId);
								for(var i=0;i<adjustBenCtrl.policyDTO.lstBenDTO.length;i++){
									if(adjustBenCtrl.policyDTO.lstBenDTO[i].benCode==undefined){
										adjustBenCtrl.policyDTO.lstBenDTO[i].benCode='NaN';
						    		}
									adjustBenCtrl.policyDTO.lstBenDTO[i].lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
								}
								adjustBenCtrl.tableParams = new NgTableParams({
									
						  	    }, {
						  	      counts: [], // hide page counts control
						  	      filterDelay: 0,
						  	      dataset: adjustBenCtrl.policyDTO.lstBenDTO
						  	    });
//								ADJUST_BEN_APP
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_APP'){
									adjustBenCtrl.checkToApproval=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_PROCESS'){
									adjustBenCtrl.checkToProcess=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_LAS'){
				    				adjustBenCtrl.checkApprove=true;
//				    		    	adjustBenCtrl.checkCancel=true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.adjustRemark!=null){
									adjustBenCtrl.cancelSuccess= true;
								}
								if(adjustBenCtrl.policyDTO.transactions.wfStatus=='ADJUST_BEN_END'&&adjustBenCtrl.policyDTO.transactions.txnEnable=='1'){
									adjustBenCtrl.finish= true;
								}
							}
						}, function(error){
							adjustBenCtrl.poInfo = {};
							adjustBenCtrl.pvInfo = {}
			    		});
					}
					
					
			 }, function(error){
				 adjustBenCtrl.poInfo = {};
				 adjustBenCtrl.pvInfo = {};
    			});
		}
		
		adjustBenCtrl.approve=function(){
			delete adjustBenCtrl.policyDTO.lstBenDTO;
			adjustBenCtrl.policyDTO.lstBenDTO=adjustBenCtrl.tableParams.data;
			adjustBenCtrl.checkApprove=true;
			$scope.loading=true;
			AdjustBenService.post({uri:'doApproveBen'},adjustBenCtrl.policyDTO, function(result) {
						 if(result){
							adjustBenCtrl.lstRelationShip=AdjustBenService.query({uri:'getBenRelationShip'});
							for(var i=0;i<result.lstBenDTO.length;i++){
									result.lstBenDTO[i].lstRelationShip=adjustBenCtrl.lstRelationShip;
							}
						    adjustBenCtrl.tableParams = new NgTableParams({
										
							 }, {
							    counts: [], // hide page counts control
							    filterDelay: 0,
							  	dataset: result.lstBenDTO
							 });
							adjustBenCtrl.tableParams.reload();
							 if(result.flagError==0){
								 adjustBenCtrl.checkToApproval=false;
								 adjustBenCtrl.finish= true;
								 
							 }else{
								 adjustBenCtrl.checkApprove=false;
							 }
							 $scope.loading=false;
						 }
					}, function(error){
						 $scope.loading=false;
						adjustBenCtrl.checkApprove=false;
    			});
		}
		adjustBenCtrl.finishBen=function(){
			adjustBenCtrl.checkApprove=true;
			$scope.loading=true;
			AdjustBenService.post({uri:'doFinishBen'},adjustBenCtrl.policyDTO, function(result) {
						 if(result){
							 $scope.loading=false;
							 if(result.flagError==0){
								 adjustBenCtrl.checkToProcess=false;
							 }
						 }
					}, function(error){
						 $scope.loading=false;
						 adjustBenCtrl.checkToProcess=true;
    			});
		}
		adjustBenCtrl.release=function(){
			AdjustBenService.post({uri:'doReleaseApprove'},adjustBenCtrl.policyDTO, function(result) {
						 if(result){
							 window.location.href = GLOBAL_URL+'task#/common-task';
						 }
					}, function(error){
    		});
		}
		
		adjustBenCtrl.downloadId = function() {
			//danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				if(adjustBenCtrl.attachmentLstDL.content!=undefined){
					var byteCharacters = atob(adjustBenCtrl.attachmentLstDL.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: adjustBenCtrl.attachmentLstDL.type+';charset=utf-8' });
					window.navigator.msSaveBlob(blob, adjustBenCtrl.attachmentLstDL.name);
				}else{
					 var blob=new Blob([adjustBenCtrl.attachmentLstDL], { type: adjustBenCtrl.attachmentLstDL.type+';charset=utf-8' });
					 window.navigator.msSaveBlob(blob, adjustBenCtrl.attachmentLstDL.name);
				 }
			}else{
				//truong hop file da luu duoi database
				if(adjustBenCtrl.attachmentLstDL.content!=undefined){
					var byteCharacters = atob(adjustBenCtrl.attachmentLstDL.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: adjustBenCtrl.attachmentLstDL.type+';charset=utf-8' });
				    var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = adjustBenCtrl.attachmentLstDL.name;
		    		aTag.click();
				}else{
					//truong hop file luu tam tren man hinh
					var blob=new Blob([adjustBenCtrl.attachmentLstDL], { type: adjustBenCtrl.attachmentLstDL.type+';charset=utf-8' });
					var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = adjustBenCtrl.attachmentLstDL.name;
		    		aTag.click();
				}
			}
		}
		
		adjustBenCtrl.save = function() {

			if (adjustBenCtrl.attachmentLst) {
				var size = 0;
				for (var i = 0; i < adjustBenCtrl.attachmentLst.length; i++) {
					var array_element = adjustBenCtrl.attachmentLst[i];
					size = size + array_element.size;
				}
				if (size > 10000000) {
					$scope.addAlert('Vui lòng chọn file có dung lượng tối đa 10MB.', 'warning');
					return;
				}
			}
			
			var data = [];
			adjustBenCtrl.checkCreate = true;
			$scope.loading=true;
			if (adjustBenCtrl.policyDTO.policyNum !== null) {
				var lstBenDTO=adjustBenCtrl.tableParams.data;
				for(var i=0;i<lstBenDTO.length;i++){
					lstBenDTO[i].customer.birthDate=new Date(lstBenDTO[i].customer.birthDate).AddDays(1);
					if(lstBenDTO[i].customer.idNumDate!=null||lstBenDTO[i].customer.idNumDate!=undefined){
						lstBenDTO[i].customer.idNumDate=new Date(lstBenDTO[i].customer.idNumDate).AddDays(1);
					}
					lstBenDTO[i].customer.mobileCode=Number(lstBenDTO[i].customer.mobileCode);
					lstBenDTO[i].customer.locationCode=lstBenDTO[i].customer.wardCode;
				}
				adjustBenCtrl.policyDTO.lstBenDTO=adjustBenCtrl.tableParams.data;
				adjustBenCtrl.policyDTO.policyOwner=adjustBenCtrl.policyDTO.ownerName;
				adjustBenCtrl.policyDTO.policyOwnerCode=adjustBenCtrl.policyDTO.ownerCode;
				if(adjustBenCtrl.checkError){
					data['file'] = adjustBenCtrl.attachment;
					data['adjustOwnerBenDTO'] = new Blob([ JSON
							.stringify(adjustBenCtrl.policyDTO) ], {
						type : "application/json"
					});
				}else{
					if (adjustBenCtrl.adjustBenForm.file.$valid && adjustBenCtrl.attachment) {
						data['file'] = adjustBenCtrl.attachment;
						data['adjustOwnerBenDTO'] = new Blob([ JSON
								.stringify(adjustBenCtrl.policyDTO) ], {
							type : "application/json"
						});
					}
				}
				
				if (adjustBenCtrl.attachmentLst) {
					for (var i = 0; i < adjustBenCtrl.attachmentLst.length; i++) {
						var array_element = adjustBenCtrl.attachmentLst[i];
						data['fileAttach' + i] = array_element;
					}
				}
				
				Upload.upload(
						{
							url : GLOBAL_URL
									+ 'api/ga/adjustben/doSaveBen?access_token='
									+ authExpiredInterceptor.getToken(),
							data : data
						}).then(
						function(resp) {
							 if(resp.data.flagError==0){
								adjustBenCtrl.checkCreate = true;
								adjustBenCtrl.adjustBenForm.$setPristine();
								adjustBenCtrl.adjustBenForm.$setUntouched();
								
								if (resp.data.archiveDataId != null) {
									adjustBenCtrl.attachmentLstDL = {name:resp.data.archiveDataId.dataName,content:resp.data.archiveDataId.content,type:resp.data.archiveDataId.dataType};
								}
								
								if(resp.data.txnId!=null){
									window.location.href = GLOBAL_URL + 'ga/opinion/#/opinion' + '/' + $base64.encode(resp.data.txnId) + '/' + $base64.encode(resp.data.policyNum);
								}
							 } else {
								adjustBenCtrl.checkCreate = false;
								adjustBenCtrl.checkError=true;
							 }
							 $scope.loading=false;
						},
						function(error) {
							adjustBenCtrl.checkCreate = false;
							$log.debug('Error status: ' + error.status);
							adjustBenCtrl.checkError=true;
							$scope.loading=false;
						},
						function(evt) {
							var progressPercentage = parseInt(100.0
									* evt.loaded / evt.total);
							$log.debug('progress: ' + progressPercentage + '% '
									+ evt.config.data.file.name);
						});
			}
		}
		//end
		adjustBenCtrl.openPending=function(){
			$scope.animationsEnabled = true;
			var modalInstance = $uibModal.open({
			      animation: $scope.animationsEnabled,
			      templateUrl: GLOBAL_URL
					+ 'partial?uri=ga/adjustben/adjustben-pending-dialog',
			      controller: 'AdjustBenPendingDialogController as adjustBenPendingDial',
			      size: 'lg',
			      resolve: {
			    	  txnId: function () {
				          return  $base64.decode(param.txnId);
			    	  },
			    	  taskInstanceId: function () {
				          return  $base64.decode(param.taskId);
			    	  }
			      }
			    });
		}
		adjustBenCtrl.findReceiver=function(){
			if(adjustBenCtrl.policyDTO.customer.idNum!=undefined){
			$scope.loading=true;
			AdjustBenService.query({uri:'getCustomerByIdNum',
				idNum : adjustBenCtrl.policyDTO.customer.idNum}, function(result) {
					adjustBenCtrl.adjustBenForm.$setPristine();
					$scope.loading=false;
						if(result.length==1){
							if(result[0].agentFlag>0){
								$scope.addAlert('Khách hàng hiện là Đại lý cùa Prudential','warning');
							}
							adjustBenCtrl.policyDTO.customer = result[0];
							adjustBenCtrl.policyDTO.customer.mobileCode=result[0].mobileCode+'';
							adjustBenCtrl.districtCode=adjustBenCtrl.policyDTO.customer.districtCode;
							if(result !=null){
					    		adjustBenCtrl.checkData=true;
					    		if(adjustBenCtrl.policyDTO.customer.birthDate!=null || adjustBenCtrl.policyDTO.customer.birthDate!= undefined){
					    			adjustBenCtrl.birthDate = new Date(adjustBenCtrl.policyDTO.customer.birthDate);
					    		}
					    		if(adjustBenCtrl.policyDTO.customer.idNumDate!=null || adjustBenCtrl.policyDTO.customer.idNumDate!= undefined){
					    			adjustBenCtrl.idNumDate = new Date(adjustBenCtrl.policyDTO.customer.idNumDate);
					    		}
					    		CommonService.query({masterurl:'district',provinceCode:adjustBenCtrl.policyDTO.customer.provinceCode},function(resultDistrict){
					    			adjustBenCtrl.lstDistrict = resultDistrict;
					    		});
					    		CommonService.query({masterurl:'ward',districtCode:adjustBenCtrl.policyDTO.customer.districtCode},function(resultWard){
					    			adjustBenCtrl.lstWard = resultWard;
					    		});
					    	}else{
					    		adjustBenCtrl.checkData=false;
					    	}
						}else if(result.length>1){
							if(result[0].agentFlag>0){
								$scope.addAlert('Khách hàng hiện là Đại lý cùa Prudential','warning');
							}
							adjustBenCtrl.items = result;
							$scope.animationsEnabled = true;
							var modalInstance = $uibModal.open({
						      animation: $scope.animationsEnabled,
						      templateUrl: GLOBAL_URL
								+ 'partial?uri=ga/adjustben/adjustben-dialog',
						      controller: 'AdjustBenDialogController as adjustBenDial',
						      size: 'lg',
						      resolve: {
						        items: function () {
						          return adjustBenCtrl.items;
						        }
						      }
						    });
		
							 modalInstance.result.then(function (selectedItem) {
							    	adjustBenCtrl.policyDTO.customer = selectedItem;
							    	adjustBenCtrl.policyDTO.customer.mobileCode=selectedItem.mobileCode+'';
							    	if(selectedItem !=null){
							    		adjustBenCtrl.checkData=true;
							    		adjustBenCtrl.birthDate = new Date(adjustBenCtrl.policyDTO.customer.birthDate);
							    		adjustBenCtrl.idNumDate = new Date(adjustBenCtrl.policyDTO.customer.idNumDate);
							    		CommonService.query({masterurl:'district',provinceCode:adjustBenCtrl.policyDTO.customer.provinceCode},function(resultDistrict){
							    			adjustBenCtrl.lstDistrict = resultDistrict;
							    		});
							    		CommonService.query({masterurl:'ward',districtCode:adjustBenCtrl.policyDTO.customer.districtCode},function(resultWard){
							    			adjustBenCtrl.lstWard = resultWard;
							    		});
							    	}else{
							    		adjustBenCtrl.checkData=false;
							    	}
							    }, function () {
							    });
						}else{
							adjustBenCtrl.idNum=adjustBenCtrl.policyDTO.customer.idNum;
							delete adjustBenCtrl.birthDate;
							delete adjustBenCtrl.idNumDate;
				    		delete adjustBenCtrl.policyDTO.customer;
				    		adjustBenCtrl.policyDTO.customer = {idNum: adjustBenCtrl.idNum};
				    		$scope.addAlert('Chưa tồn tại khách hàng có số khai sinh/ CMND ['+ adjustBenCtrl.idNum +'].','error');
						}
			},function(error){
					adjustBenCtrl.policyDTO.customer=null;
					adjustBenCtrl.birthDate=null;
					adjustBenCtrl.idNumDate=null;
					adjustBenCtrl.lstWard=null;
					adjustBenCtrl.lstDistrict=null;
					$scope.loading=false;
			});
			}
		}
		adjustBenCtrl.editInfo = function(idx) {
			if (adjustBenCtrl.tableParams.data[idx].benCode=='NaN') {
				if(!adjustBenCtrl.checkCreate){
				var modalInstance = $uibModal
						.open({
							animation : $scope.animationsEnabled,
							templateUrl : GLOBAL_URL
									+ 'partial?uri=ga/adjustben/adjustben-dialog-edit',
							controller : 'AdjustBenDialogEditController as adjustBenDialEdit',
							size : 'lg',
							resolve : {
								index : function() {
									return idx;
								},
								items : function() {
									return adjustBenCtrl.tableParams.data[idx];
								}
							}
						});
				modalInstance.result.then(function(selectedItem) {
					adjustBenCtrl.tableParams.data
							.splice(selectedItem.index, 1);
					adjustBenCtrl.lstReceiver.splice(selectedItem.index, 1);
					adjustBenCtrl.tableParams.reload();
					adjustBenCtrl.lstReceiver=adjustBenCtrl.tableParams.data;
					adjustBenCtrl.policyDTO.customer = selectedItem.customer;
					adjustBenCtrl.policyDTO.benName=selectedItem.customer.lastName.toUpperCase() + ' ' + selectedItem.customer.firstName.toUpperCase();
					adjustBenCtrl.policyDTO.benRatio=selectedItem.benRatio;
					adjustBenCtrl.policyDTO.benRelation=selectedItem.benRelation;
					adjustBenCtrl.policyDTO.adjustBenId=selectedItem.adjustBenId;
					adjustBenCtrl.birthDate = new Date(
							adjustBenCtrl.policyDTO.customer.birthDate);
					adjustBenCtrl.idNumDate = new Date(
							adjustBenCtrl.policyDTO.customer.idNumDate);
					adjustBenCtrl.editReceiver();
					// if(selectedItem !=null){
					// adjustBenCtrl.checkData=true;
					// adjustBenCtrl.birthDate = new
					// Date(adjustBenCtrl.policyDTO.customer.birthDate);
					// CommonService.query({masterurl:'district',provinceCode:adjustBenCtrl.policyDTO.customer.provinceCode},function(resultDistrict){
					// adjustBenCtrl.lstDistrict = resultDistrict;
					// });
					// CommonService.query({masterurl:'ward',districtCode:adjustBenCtrl.policyDTO.customer.districtCode},function(resultWard){
					// adjustBenCtrl.lstWard = resultWard;
					// });
					// }else{
					// adjustBenCtrl.checkData=false;
					// }
				}, function() {
				});
				}else{
					var modalInstance = $uibModal
					.open({
						animation : $scope.animationsEnabled,
						templateUrl : GLOBAL_URL
								+ 'partial?uri=ga/adjustben/adjustben-dialog-info',
						controller : 'AdjustBenDialogInfoController as adjustBenDialInfo',
						size : 'lg',
						resolve : {
							index : function() {
								return idx;
							},
							items : function() {
								return adjustBenCtrl.tableParams.data[idx];
							}
						}
					});
				}
			}else{
				var modalInstance = $uibModal
				.open({
					animation : $scope.animationsEnabled,
					templateUrl : GLOBAL_URL
							+ 'partial?uri=ga/adjustben/adjustben-dialog-info',
					controller : 'AdjustBenDialogInfoController as adjustBenDialInfo',
					size : 'lg',
					resolve : {
						index : function() {
							return idx;
						},
						items : function() {
							return adjustBenCtrl.tableParams.data[idx];
						}
					}
				});
			}
		}
		adjustBenCtrl.benCancelReason = function(adjusPoId){
    		if (adjusPoId == undefined || adjusPoId == null) return false;
    		adjustBenCtrl.lstBenReason = AdjustBenService.query({uri:'ben-cancel-reason'}, function(data){
    			adjustBenCtrl.animationsEnabled = true;
				var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : adjustBenCtrl.animationsEnabled,
						templateUrl : GLOBAL_URL+'partial?uri=ga/adjustben/adjustben-cancel-reason-dialog',
						controller : 'BenCancelReasonDialogController as cancelReasonDlgCtr',
						size : 'lg',
						resolve : {
							lstBenReason : function() {
								return data;//tranfer data for dialog
							},
							adjustBen: function(){
								return adjustBenCtrl.policyDTO;
							}
						}
				});
				modalInstance.result.then(
						function(result) {
							adjustBenCtrl.cancelSuccess= true;
							adjustBenCtrl.checkToApproval= false;
						},
						function(error){
							
						});
    		},
    		function(error){
    			AlertService.error(error.data.message);
    		});
		}
		adjustBenCtrl.checkSignature = function (policyNum){
			if (policyNum == undefined || policyNum == null) return false;
			FileNetService.query({method:'get-list-poldoc',polNum:policyNum}, function(result){
				if(result.length >0){
					adjustBenCtrl.animationsEnabled = true;
					var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : adjustBenCtrl.animationsEnabled,
						templateUrl : GLOBAL_URL+'partial?uri=ga/signature/signature-dialog',
						controller : 'SignatureDialogController as signatureDlgCtrl',
						size : 'lg',
						resolve : {
							items : function() {
								return result;//tranfer data for dialog
							}
						}
					});
					modalInstance.result.then(
					function(result) {
					},
					function(error){
					});
				}else{
					$scope.addAlert('File chữ ký HD ['+policyNum+'] không tồn tại.Vui lòng kiểm tra lại','warning');
				}
    		},
    		function(error){
    		});
		};
		adjustBenCtrl.printBen = function() {
        	if(adjustBenCtrl.policyDTO.transactions.txnId != undefined){
        		var benReport = {txnId:adjustBenCtrl.policyDTO.transactions.txnId,policyNum:adjustBenCtrl.policyDTO.policyNum};
        		AdjustBenService.download({uri:'print-ben'}, benReport);
        	}
        	
        }
		adjustBenCtrl.download=function() {
			//danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				if(adjustBenCtrl.attachment.content!=undefined){
					var byteCharacters = atob(adjustBenCtrl.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: adjustBenCtrl.attachment.type+';charset=utf-8' });
					window.navigator.msSaveBlob(blob, adjustBenCtrl.attachment.name);
				}else{
					 var blob=new Blob([adjustBenCtrl.attachment], { type: adjustBenCtrl.attachment.type+';charset=utf-8' });
					 window.navigator.msSaveBlob(blob, adjustBenCtrl.attachment.name);
				 }
			}else{
				//truong hop file da luu duoi database
				if(adjustBenCtrl.attachment.content!=undefined){
					var byteCharacters = atob(adjustBenCtrl.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
					    byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob=new Blob([byteArray], { type: adjustBenCtrl.attachment.type+';charset=utf-8' });
				    var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = adjustBenCtrl.attachment.name;
		    		aTag.click();
				}else{
					//truong hop file luu tam tren man hinh
					var blob=new Blob([adjustBenCtrl.attachment], { type: adjustBenCtrl.attachment.type+';charset=utf-8' });
					var url = $window.URL || $window.webkitURL;
				    var aTag = document.createElement("a");
		    		aTag.style = "display: none";
		    		aTag.href = url.createObjectURL(blob);
		    		aTag.download = adjustBenCtrl.attachment.name;
		    		aTag.click();
				}
			}
		}
		//Add days
    	Date.prototype.AddDays = function(noOfDays) {
    	    this.setTime(this.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
    	    return this;
    	};
		adjustBenCtrl.dob = new Date();
		adjustBenCtrl.openDob = function() {
			adjustBenCtrl.popupDob.opened = true;
		};
		adjustBenCtrl.didNum = new Date();
		adjustBenCtrl.openDidNum = function() {
			adjustBenCtrl.popupDidNum.opened = true;
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'M!/d!/yyyy' ];
		adjustBenCtrl.popupDob = {
			opened : false
		};
		adjustBenCtrl.popupDidNum = {
				opened : false
			};
	}

})();
